import React from "react";

const SvgRpm = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 24 20" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="Rpm_svg__a"
        d="M529.298 729.836L526.884 732c-1.859-2.187-2.884-4.997-2.884-7.919 0-6.657 5.266-12.081 11.749-12.081 1.506 0 2.937.284 4.251.824l-2.563 2.635a8.545 8.545 0 0 0-1.688-.164c-4.71 0-8.545 3.942-8.545 8.786 0 2.13.737 4.173 2.094 5.755zm10.189-5.984c.072.272.123.552.123.845a3.303 3.303 0 0 1-3.305 3.303 3.303 3.303 0 1 1 0-6.605c.294 0 .575.05.846.123h.002l6.522-6.518c.882.66 1.664 1.452 2.325 2.345zm7.807-3.852c.454 1.302.706 2.712.706 4.178 0 2.886-.968 5.662-2.722 7.822L543 729.863c1.28-1.564 1.976-3.581 1.976-5.685a8.52 8.52 0 0 0-.131-1.54z"
      />
    </defs>
    <use
      fill="currentColor"
      xlinkHref="#Rpm_svg__a"
      transform="translate(-524 -712)"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgRpm svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/Rpm.js